/**
 * @file AgreeSupporterPolicy
 */

'use strict';

/**
 * @classname AgreeSupporterPolicy
 * @classdesc 規約同意
 */
export default class AgreeSupporterPolicy {
	/**
	 * @constructor
	 * @param {jQuery} $e - '$(#agree-policy')
	 */
	constructor($e, controller) {
		console.log(`AgreeSupporterPolicy.constructor`);
		this._$e = $e;
		this._$parentAgree = $('#parent-agree');
		this._$target = $('#parent-agree-wrap');
		this._$btn = $('#btn-registration');
		$e.on('click', () => {
			this.onClick();
		});
		this._$parentAgree.on('click', () => {
			this.onClick();
		});
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof AgreeSupporterPolicy
	 * @return {undefined}
	 */
	onClick() {
		console.log(`AgreeSupporterPolicy.onClick`);
		let checked = false;
		let cnt = 0;
		if(this._$target.css('display') === 'none'){
			console.log('保護者同意close');
			if($('#agree-policy').prop('checked')) {
				this._$btn.prop('disabled', false);
			}else{
				this._$btn.prop('disabled', true);
			}
		}else{
			console.log('保護者同意open');
			if($('#agree-policy').prop('checked')) cnt ++;
			if($('#parent-agree').prop('checked')) cnt ++;
			if(cnt == 2) {
				this._$btn.prop('disabled', false);
			}else{
				this._$btn.prop('disabled', true);
			}
		}
	};
}
